module.exports = __webpack_public_path__ + "img/advantage2.b32f3579.png";